
(() => {
  document.querySelectorAll('[data-pp-accessory]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const panels = [...root.querySelectorAll('[data-media-panel]')];
    const thumbs = [...root.querySelectorAll('[data-media-target]')];
    const showMedia = id => {
      if (!panels.some(panel => panel.dataset.mediaPanel === String(id))) return;
      panels.forEach(panel => {
        const active = panel.dataset.mediaPanel === String(id);
        panel.hidden = !active;
        if (!active) {
          panel.querySelectorAll('video').forEach(video => video.pause());
          panel.querySelectorAll('iframe').forEach(frame => {
            if (frame.src.includes('youtube')) frame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), new URL(frame.src).origin);
            if (frame.src.includes('vimeo')) frame.contentWindow?.postMessage({method:'pause'}, new URL(frame.src).origin);
          });
        }
      });
      thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb.dataset.mediaTarget === String(id))));
    };
    thumbs.forEach(thumb => thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaTarget)));
    const form = root.querySelector('.ppa-form');
    if (!form) return;
    const variants = JSON.parse(root.querySelector('[data-accessory-variants]').textContent);
    const variantSelect = form.querySelector('[name="id"]');
    const planSelect = form.querySelector('[name="selling_plan"]');
    const submit = form.querySelector('[type="submit"]');
    const error = form.querySelector('.ppa-error');
    let pending = false;
    const urlPlan = new URL(location.href).searchParams.get('selling_plan') || '';
    function update(rebuild = false, requestedPlan = null) {
      const variant = variants.find(value => String(value.id) === variantSelect.value);
      if (!variant) return;
      if (rebuild && planSelect) {
        const selectedPlan = requestedPlan ?? planSelect.value;
        const supportsOnce = planSelect.querySelector('option[value=""]') !== null;
        planSelect.replaceChildren(...(supportsOnce ? [new Option('One-time purchase', '')] : []), ...variant.plans.map(plan => new Option(plan.name, plan.id)));
        if ([...planSelect.options].some(option => option.value === selectedPlan)) planSelect.value = selectedPlan;
        planSelect.disabled = !planSelect.options.length;
      }
      const plan = variant.plans.find(value => String(value.id) === planSelect?.value);
      root.querySelector('[data-accessory-price]').textContent = plan?.price || variant.price;
      const giftValue = root.querySelector('[data-gift-value]');
      if (giftValue) giftValue.textContent = variant.price;
      submit.disabled = pending || !variant.available;
      submit.textContent = pending ? 'Adding…' : variant.available ? 'Add to cart' : 'Sold out';
      if (rebuild && variant.media) showMedia(variant.media);
    }
    root.querySelectorAll('[data-preview-variant]').forEach(button => {
      button.addEventListener('click', () => {
        variantSelect.value = button.dataset.previewVariant;
        root.querySelectorAll('[data-preview-variant]').forEach(option => option.setAttribute('aria-pressed', String(option === button)));
        update(true);
        error.hidden = true;
      });
    });
    variantSelect.addEventListener('change', () => {
      update(true);
      error.hidden = true;
      const url = new URL(location.href);
      url.searchParams.set('variant', variantSelect.value);
      if (planSelect?.value) url.searchParams.set('selling_plan', planSelect.value);
      else url.searchParams.delete('selling_plan');
      // The existing gift and payment apps initialize from Shopify's server-selected variant.
      // Reload this product variant so every purchase path uses the chosen denomination.
      if (root.dataset.kind === 'giftcard') { location.assign(url.toString()); return; }
      history.replaceState(null, '', url);
    });
    planSelect?.addEventListener('change', () => update());
    update(true, urlPlan);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (pending || !form.reportValidity()) return;
      pending = true;
      error.hidden = true;
      update();
      try {
        const data = new FormData(form);
        if (!data.get('selling_plan')) data.delete('selling_plan');
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST', headers: {Accept:'application/json'}, body: data
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
        location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      } catch (failure) {
        error.textContent = failure.message;
        error.hidden = false;
        pending = false;
        update();
      }
    });
  });
})();
